import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";
import type { AppProps } from "next/app";
import { Provider as ReduxProvider } from "react-redux";
import { z } from "zod";

import "../../styles/globals.css";
import "../../styles/quill.winshop.scss";

import { WinShopPageProps } from "@winshop-crm/types";

import { ErrorBoundary } from "../components/Layouts/ErrorBoundary";
import { useStore } from "../store";

z.config(z.locales.cs());

function MyApp({ Component, pageProps }: AppProps<WinShopPageProps>) {
  const store = useStore(pageProps.initialReduxState);

  return (
    <ErrorBoundary>
      <NextAuthSessionProvider session={pageProps.session}>
        <ReduxProvider store={store}>
          <Component {...pageProps} />
        </ReduxProvider>
      </NextAuthSessionProvider>
    </ErrorBoundary>
  );
}

export default MyApp;
